<script setup lang="ts">
import { inject, ref, type Ref } from 'vue';
import clsx from 'clsx';

const props = defineProps<{ class?: string }>();
const classes = clsx(
  'mb-1 px-2 text-xs/6 font-medium text-zinc-500 dark:text-zinc-400',
  props.class,
);
// Section headings disappear when the sidebar collapses to an icon rail.
const collapsed = inject<Ref<boolean>>('sidebarCollapsed', ref(false));
</script>

<template>
  <h3 v-show="!collapsed" :class="classes"><slot /></h3>
</template>
